
export const productThumbnails = ()=>{
    window.customElements.define('custom-product-thumbnails', class extends HTMLElement {
        constructor() {
            super();
            this.productOptionsAttr = JSON.parse(this.dataset.productOptions);
            
            this.productOptions = this.productOptionsAttr.map((op)=>op.toLowerCase())
            this.thumbnails = this.querySelectorAll('li[data-media-alt]');
            
            const selectedVariantJson = document.querySelector('#SelectedVariantJSON');
            this.selectedVariant = selectedVariantJson ? JSON.parse(selectedVariantJson.textContent) : null;
            if(this.selectedVariant){
                this.changeThumbnailsVisibilty(this.selectedVariant);
            }
        }

        async connectedCallback() {
            this.addEventListener('product:variant:changed:custom', this.onVariantChange);
        }
        onVariantChange(event){
            const variant = event.detail.variant;
            this.changeThumbnailsVisibilty(variant)
        }
        changeThumbnailsVisibilty(variant){
            let visibleThumbnails = 0;
            this.thumbnails.forEach((thumbnail)=>{
                const alt = thumbnail.dataset.mediaAlt;
                let thumbnailMatchVariant = true;
                if(alt){
                    const options = alt.split('|').map((op)=>op.replace(/\s/g, ''));
                    options.forEach((op)=>{
                        const optionName = op.substring(0,op.indexOf(':'));
                        const optionValue = op.substring(op.indexOf(':')+1);
                        if(optionName){
                            const indexOption = this.productOptions.indexOf(optionName);
                            if(variant.options[indexOption] && variant.options[indexOption].toLowerCase() !== optionValue){
                                thumbnailMatchVariant = false;
                            }
                        }
                    })
                    if(!thumbnailMatchVariant){
                        thumbnail.setAttribute('hidden','')
                    }else{
                        thumbnail.removeAttribute('hidden','')
                        visibleThumbnails += 1;
                    }
                }
            })

            if(visibleThumbnails === 1){
                this.thumbnails.forEach((thumb)=>{
                    thumb.setAttribute('hidden','')
                })
            }
        }
    })
}

export const productQuantitySwitcher = ()=>{
    
    const productQuantity = document.querySelector('.product-swatch-quantity');
    const customQuantitySelector = document.querySelector('.product-custom-quantity-selector[data-current-product-type="true"]')
    
    if(productQuantity ||customQuantitySelector ){
        const productSwatch = productQuantity ? productQuantity.querySelector('.product-swatch') : null;
        if(productQuantity){
            productQuantity.addEventListener('click',()=>{
                const quantityRadio = document.querySelector('[data-option="quantity"]');
                    if(quantityRadio){
                        const quantityRadiosInput = quantityRadio.querySelectorAll('input');
                        quantityRadiosInput.forEach((input)=>{
                            let value = input.value;
                            if(value === '1x'){
                                input.click();
                            }
                        })
                    }
                });
        }

        window.customElements.define('multi-selector', class extends HTMLElement {
            async connectedCallback() {
                this.addEventListener('product:variant:changed', this.onVariantChange);
            }
            onVariantChange(event){
                const variant = event.detail.variant;
                if(variant.option1 == '1x' || variant.option2 == '1x' || variant.option3 == '1x'){
                    if(productSwatch){
                        productSwatch.classList.add('is-selected');  
                    }
                } else{
                    if(productSwatch){
                        productSwatch.classList.remove('is-selected');  
                    }
                }
                const quantityButtons = customQuantitySelector.querySelectorAll('.product-custom-quantity-button[data-is-product]');
                quantityButtons.forEach((button)=>{
                    const buttonSwatch = button.querySelector('.product-swatch')
                    const buttonValue = button.dataset.value;
                    if(buttonValue == variant.option1 || buttonValue == variant.option2 || buttonValue == variant.option3){
                        buttonSwatch.classList.add('is-selected')
                    } else{
                        buttonSwatch.classList.remove('is-selected')
                    }
                })
            }
        })

        if(customQuantitySelector){
            const quantityButtons = customQuantitySelector.querySelectorAll('.product-custom-quantity-button[data-is-product]');
            quantityButtons.forEach((button)=>{
                button.addEventListener('click',() => {
                    const buttonValue = button.dataset.value;
                    const quantityRadio = document.querySelector('[data-option="quantity"]');
                    if(quantityRadio){
                        const quantityRadiosInput = quantityRadio.querySelectorAll('input');
                        quantityRadiosInput.forEach((input)=>{
                            let value = input.value;
                            if(value === buttonValue){
                                input.click();
                            }
                        })
                    }
                })
            })
        }
    }
}

export const productTabMenu = ()=>{
    const tabLink = document.querySelectorAll('.tab_menu button');
    const swatchList = document.querySelectorAll(`.content__product-type`)
    if(tabLink && tabLink.length > 0){
        tabLink.forEach((tab)=>{
            tab.addEventListener('click',()=>{
                let tabType = tab.dataset.type;
                swatchList.forEach((list)=>{
                    const type = list.dataset.type;
                    if(type == tabType){
                        list.classList.add('current');
                    }else{
                        list.classList.remove('current');
                    }
                })
                tabLink.forEach((t)=>{
                    t.classList.remove('current');
                })
                tab.classList.add('current');
            })
        })
    }
}